module.exports = __webpack_public_path__ + "static/media/layer_2.471bf223.svg";